'use client';

import dynamic from 'next/dynamic';

export const PricingCards = dynamic(() => import('./PricingCards'));
export const Features = dynamic(() => import('./Features'));
export const PaymentMethods = dynamic(() =>
  import('./PaymentMethods').then((m) => m.PaymentMethods)
);
